/**
 * @generated SignedSource<<d7a4326dd48ce4b1d97dd03dcf7acc4f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AvailabilityCreateInput = {
  practitionerId: string;
  start: any;
  end: any;
  isRecurring: boolean;
};
export type userCreateAvailabilityMutation$variables = {
  input: AvailabilityCreateInput;
};
export type userCreateAvailabilityMutation$data = {
  readonly createAvailability: boolean;
};
export type userCreateAvailabilityMutation = {
  variables: userCreateAvailabilityMutation$variables;
  response: userCreateAvailabilityMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "kind": "ScalarField",
    "name": "createAvailability",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "userCreateAvailabilityMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "userCreateAvailabilityMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "89df2b132fdc75a0e73e415a19f372f5",
    "id": null,
    "metadata": {},
    "name": "userCreateAvailabilityMutation",
    "operationKind": "mutation",
    "text": "mutation userCreateAvailabilityMutation(\n  $input: AvailabilityCreateInput!\n) {\n  createAvailability(input: $input)\n}\n"
  }
};
})();

(node as any).hash = "149a545a85a4302acf27f4c9270c47f8";

export default node;
